import React from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const tomos = [{
    id: 1,
    emoji: '📗',
    title: 'Fundamentos de la Geología',
    subtitle: 'Todo lo que necesitás saber antes de entrar al aula o explicar tu primera roca',
    desc: 'Historia de la Geología, formación de la Tierra, estructura interna del planeta, minerales, rocas, ciclo de las rocas, tiempo geológico, métodos de datación, cartografía geológica e introducción al trabajo de campo. Con guías de lectura, vocabulario de referencia y material imprimible listo para usar en clase.',
    resuelve: 'El primer contacto del alumno con la Geología es decisivo. Este tomo te da la base para hablar con autoridad desde el primer día del ciclo lectivo.',
    resultado: 'Tus alumnos sienten que están aprendiendo algo real y conectado con Argentina. Eso genera atención y eso genera aprendizaje.',
    tags: ['HISTORIA', 'MINERALES', 'ROCAS', 'TIEMPO GEOLÓGICO', 'CARTOGRAFÍA']
  }, {
    id: 2,
    emoji: '📗',
    title: 'Mineralogía y Petrología',
    subtitle: 'Conocé cada mineral y cada roca como si los hubieras tomado con tus propias manos',
    desc: 'Cristalografía, propiedades físicas de los minerales, identificación de minerales, minerales formadores de roca, rocas ígneas, sedimentarias y metamórficas, procesos de formación y aplicaciones industriales. Todo con ejemplos de las Sierras Pampeanas, la Patagonia y la Puna argentina.',
    resuelve: 'Cuando un alumno pregunta "¿para qué sirve saber esto?", este tomo te da la respuesta exacta con la rodocrosita de Catamarca, el talco de San Luis y los granitos de Córdoba.',
    resultado: 'Convertís cada clase práctica en una experiencia significativa porque tus ejemplos son del territorio que tus alumnos habitan.',
    tags: ['CRISTALOGRAFÍA', 'MINERALES', 'ROCAS ÍGNEAS', 'METAMÓRFICAS', 'ARGENTINA']
  }, {
    id: 3,
    emoji: '📗',
    title: 'Geología Estructural y Tectónica',
    subtitle: 'Argentina tiene la geología más dinámica de América del Sur. Aprendé a enseñarla así.',
    desc: 'Tectónica de Placas, Deriva Continental, fallas geológicas, pliegues, diaclasas, esfuerzos geológicos, formación de montañas, vulcanismo, sismicidad y riesgos geológicos. Con esquemas, diagramas y el caso real del Terremoto de San Juan de 1944 y los volcanes de Neuquén.',
    resuelve: 'Un alumno que pregunta "¿por qué tiembla San Juan pero no Buenos Aires?" merece una respuesta que lo deje con la boca abierta... y con ganas de seguir aprendiendo.',
    resultado: 'Tus alumnos entienden por qué Argentina tiene los Andes, los terremotos y los volcanes que tiene. Y eso convierte la Geología en algo urgente y real.',
    tags: ['TECTÓNICA', 'FALLAS', 'PLIEGUES', 'VOLCANES', 'SISMICIDAD']
  }, {
    id: 4,
    emoji: '📗',
    title: 'Geomorfología y Procesos Externos',
    subtitle: 'El tomo que te transforma de docente de Geología a intérprete del paisaje argentino',
    desc: 'Meteorización, erosión, transporte de sedimentos, sedimentación, geología fluvial, geología glaciar, geología costera, ambientes desérticos, relieves de Argentina y evolución del paisaje. Con el Perito Moreno, la Quebrada de Humahuaca, el Delta del Paraná y la Meseta Patagónica como protagonistas.',
    resuelve: 'Enseñar geomorfología es la herramienta que te permite conectar los procesos geológicos con el paisaje que tus alumnos ven en las vacaciones, en los noticieros y en sus provincias.',
    resultado: 'Podés llevar la realidad del país al aula y hacer que tus alumnos miren un paisaje argentino y entiendan qué proceso geológico lo formó.',
    tags: ['GLACIARES', 'RÍOS', 'COSTAS', 'DESIERTOS', 'RELIEVES ARGENTINOS']
  }, {
    id: 5,
    emoji: '📗',
    title: 'Geología Aplicada',
    subtitle: 'Que cada concepto que enseñes tenga un impacto real en la vida de tus alumnos',
    desc: 'Hidrogeología, geología ambiental, geología urbana, geotecnia, estudios de suelo, geología para obras civiles, minería, exploración geológica, prospección minera y evaluación de riesgos geológicos. Con el Acuífero Guaraní, el Riachuelo, los terremotos de San Juan y Vaca Muerta como casos reales.',
    resuelve: 'La Geología Aplicada es la respuesta definitiva a "¿para qué sirve esto?". Este tomo convierte cada clase en una lección de ciudadanía geológica argentina.',
    resultado: 'Tus alumnos comprenden que la Geología está en el agua que toman, en el suelo que pisan, en el gas que calienta sus casas y en el litio de sus celulares.',
    tags: ['HIDROGEOLOGÍA', 'MINERÍA', 'GEOTECNIA', 'RIESGOS', 'VACA MUERTA'],
    featured: true
  }, {
    id: 6,
    emoji: '⭐',
    title: 'Recursos Naturales y Geología Argentina',
    subtitle: 'El tomo que cierra el ciclo y conecta la Geología con la identidad y el futuro del país',
    desc: 'Recursos minerales, recursos energéticos, petróleo, gas natural, litio, geología regional argentina, Cordillera de los Andes, Patagonia, Sierras Pampeanas y conservación del patrimonio geológico. Todo el territorio argentino explicado desde sus raíces geológicas.',
    resuelve: 'Este tomo te da el marco para que tus alumnos entiendan por qué Argentina es una potencia geológica y qué decisiones como sociedad deben tomar sobre sus recursos.',
    resultado: 'Pasás de enseñar contenidos sueltos a construir una visión completa del territorio argentino. Tus alumnos terminan el año entendiendo su país de una forma que ninguna otra materia les da.',
    tags: ['LITIO', 'PETRÓLEO', 'ANDES', 'PATAGONIA', 'PATRIMONIO GEOLÓGICO'],
    badge: '⭐ EL MÁS POPULAR'
  }];
  const bonos = [{
    id: 1,
    title: 'Banco de Actividades para Docentes',
    valor: '$18.000 ARS',
    desc: 'Más de 112 actividades listas para usar: individuales, grupales, trabajos prácticos de laboratorio, guías de campo, estudios de caso, actividades de observación, proyectos interdisciplinarios y fichas imprimibles. Todo contextualizado en Argentina. Sin preparación adicional del docente.'
  }, {
    id: 2,
    title: 'Banco de Imágenes Geológicas Argentinas',
    valor: '$15.000 ARS',
    desc: '20 galerías temáticas con fichas detalladas: minerales, rocas, fósiles, volcanes, fallas, pliegues, estratos, mapas, relieves y fotografías comentadas para proyectar en clase. Cada imagen con descripción geológica, guión docente y preguntas de análisis. Todo de sitios argentinos reales.'
  }, {
    id: 3,
    title: 'Banco de Evaluaciones',
    valor: '$12.000 ARS',
    desc: 'Evaluaciones diagnósticas, formativas e integradoras. Banco de 30 preguntas de opción múltiple, 30 verdadero/falso con justificación, preguntas de desarrollo, resolución de casos reales argentinos, rúbricas de evaluación y autoevaluaciones. Con claves de corrección completas.'
  }, {
    id: 4,
    title: 'Presentaciones para Clase',
    valor: '$10.000 ARS',
    desc: '12 presentaciones completas con estructura de diapositivas y guión docente, 20 infografías geológicas argentinas, 15 esquemas conceptuales, 6 líneas de tiempo, 10 mapas conceptuales y 12 diagramas científicos. Versiones para clases presenciales y virtuales. Plantillas editables para Canva y PowerPoint.'
  }];
  return <section className="py-20 bg-[#ece2cd]" data-id="element-161">
      <div className="container mx-auto px-4" data-id="element-162">
        <div className="text-center mb-16" data-id="element-163">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1e4230] text-[#e7c766] border border-[#c8971b]/40 font-bold mb-6 text-[15px]" data-id="element-164">
            📗 LOS 6 TOMOS
          </div>
          <h2 className="text-[24px] md:text-5xl font-black text-[#1e4230] mb-4 font-[Merriweather,_serif]" data-id="element-165">
            Un tomo por cada dimensión de la Geología Argentina
          </h2>
          <p className="text-[#6f4e2e] font-medium text-[16px]" data-id="element-166">
            Todo el sistema didáctico resuelto para docentes de Argentina.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-167">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`rounded-2xl border bg-white overflow-hidden shadow-[0_10px_28px_-16px_rgba(31,50,39,0.3)] hover:shadow-[0_16px_38px_-16px_rgba(31,50,39,0.4)] transition-all flex flex-col h-full relative ${tomo.badge ? 'border-[#c8971b] border-2' : 'border-[#e0d6bf]'}`} data-id="element-168">
              {tomo.badge && <div className="absolute top-0 right-0 bg-[#c8971b] text-[#14301f] font-black text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-169">
                  {tomo.badge}
                </div>}
              <div className="bg-[#1e4230] p-4 border-b-4 border-[#c8971b] flex items-center gap-3" data-id="element-170">
                <div className="text-3xl" data-id="element-171">{tomo.emoji}</div>
                <div data-id="element-172">
                  <p className="text-xs font-bold uppercase tracking-wider text-[#e7c766]" data-id="element-173">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-[#f5efe1] text-lg leading-tight font-[Merriweather,_serif]" data-id="element-174">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-175">
                <p className="font-semibold text-[#6f4e2e] mb-3 pb-3 border-b border-[#e0d6bf]" data-id="element-176">
                  {tomo.subtitle}
                </p>
                <p className="text-[#4a4133] text-sm leading-relaxed mb-4" data-id="element-177">
                  {tomo.desc}
                </p>
                <div className="bg-[#f5efe1] p-3 rounded-lg mb-4 border border-[#e0d6bf]" data-id="element-178">
                  <p className="text-xs text-[#6f4e2e] mb-1" data-id="element-179">
                    <strong data-id="element-180">¿Qué resuelve en tu aula?</strong>
                  </p>
                  <p className="text-sm text-[#4a4133]" data-id="element-181">{tomo.resuelve}</p>
                </div>
                <div className="bg-[#eaf3ec] p-3 rounded-lg mb-4 border border-[#c6e0cf]" data-id="element-182">
                  <p className="text-xs text-[#2f6b47] mb-1" data-id="element-183">
                    <strong data-id="element-184">Resultado:</strong>
                  </p>
                  <p className="text-sm text-[#1e4230]" data-id="element-185">{tomo.resultado}</p>
                </div>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-186">
                  {tomo.tags.map((tag, j) => <span key={j} className="text-[10px] font-bold uppercase tracking-wider bg-[#e5ddc8] text-[#6f4e2e] px-2 py-1 rounded" data-id="element-187">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-12 border-t border-[#d3c8ac] pt-16" data-id="element-188">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#c8971b] text-[#14301f] font-bold mb-6 text-[15px]" data-id="element-189">
            🎁 LOS 4 BONOS ESTRATÉGICOS
          </div>
          <h2 className="text-[22px] md:text-4xl font-black text-[#1e4230] mb-4 font-[Merriweather,_serif]" data-id="element-190">
            Siempre incluidos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-191">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#e0d6bf] bg-white p-6 flex flex-col h-full relative overflow-hidden shadow-[0_10px_28px_-16px_rgba(31,50,39,0.25)]" data-id="element-192">
              <div className="absolute top-0 left-0 w-full h-1.5 bg-[repeating-linear-gradient(90deg,#c8971b,#c8971b_10px,#6f4e2e_10px,#6f4e2e_20px)]" data-id="element-193"></div>
              <h4 className="font-bold text-[#a97e12] mb-2 mt-2" data-id="element-194">
                BONO 0{bono.id}
              </h4>
              <h3 className="font-bold text-[#1e4230] text-lg mb-3 font-[Merriweather,_serif]" data-id="element-195">
                {bono.title}
              </h3>
              <p className="text-xs font-bold text-[#6f4e2e] mb-4 pb-3 border-b border-[#e0d6bf]" data-id="element-196">
                Valor real: <span className="line-through" data-id="element-197">{bono.valor}</span> →{' '}
                <span className="text-[#2f6b47]" data-id="element-198">GRATIS</span>
              </p>
              <p className="text-[#4a4133] text-sm leading-relaxed flex-grow" data-id="element-199">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-[#1e4230] rounded-2xl p-6 md:p-8 border-2 border-[#c8971b]/50 text-center shadow-2xl" data-id="element-200">
          <p className="text-[#d8d0bd] font-medium mb-2" data-id="element-201">
            Valor total de los 4 bonos: $55.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-[#f5efe1] mb-2" data-id="element-202">
            Tu precio hoy: <span className="text-[#e7c766]" data-id="element-203">🎁 GRATIS</span> con
            tu Megapack
          </p>
        </motion.div>
      </div>
    </section>;
}